import { ListLoader, ItemLoader } from "@/loaders";

export default {
  list: new ListLoader("/filter-bookmarks/", {
    setter: "filterBookmarks/setFilterBookmarks",
  }),
  item: new ItemLoader("/filter-bookmarks/", {
    setter: "filterBookmarks/updateFilterBookmark",
    remover: "filterBookmarks/deleteFilterBookmark",
  }),
};
